import { Controller } from "stimulus";

// Toggles Bootstrap tab panes by id regardless of DOM nesting. Needed on the course
// forms where the <form> wraps only some panes while the remaining panes are
// turbo-frames with their own forms — so the panes live at different nesting levels
// and Bootstrap's sibling-scoped tabs leave two or more active at once.
export default class extends Controller {
  // Deep links (/edit#service-enrollments): the course/activity controllers hand the hash to
  // the Bootstrap tab plugin, which only deactivates the siblings of the target pane, so the
  // pane inside the <form> stays open next to the one outside it. Re-apply the selection here.
  connect() {
    const hash = window.location.hash;
    if (!hash) return;

    const link = [...this.element.querySelectorAll(".nav-link")].find((el) => el.getAttribute("href") === hash);
    if (link) this.activate(link);
  }

  show(event) {
    event.preventDefault();
    this.activate(event.currentTarget);
  }

  activate(link) {
    const target = this.element.querySelector(link.getAttribute("href"));

    this.element.querySelectorAll(".nav-link").forEach((el) => el.classList.remove("active"));
    link.classList.add("active");

    this.element.querySelectorAll(".tab-pane").forEach((pane) => pane.classList.remove("active", "show"));
    if (target) target.classList.add("active", "show");
  }
}
